export default "__VITE_PUBLIC_ASSET__9debbcf3__"